import { useUpdateModal } from '@zydalabs/storefront-components';

import { useRemoveCartItems } from 'service/hooks';
import { usePersistedCartData } from 'common/hooks';
import { CartItem } from 'service/types';
import useTranslation from 'next-translate/useTranslation';
import { LANGUAGE_AR } from 'common/constants';
import { useUpdateCartValues } from 'service/hooks/cart/utils';
import { useState } from 'react';

type useRemoveCartItemsOutOfSyncType = ({
  mutateCartDetails,
  cartItems,
}: {
  mutateCartDetails: any;
  cartItems: CartItem[];
}) => { removeItemsOutOfSync: () => Promise<void>; isLoading: boolean };

export const useRemoveCartItemsOutOfSync: useRemoveCartItemsOutOfSyncType = ({ mutateCartDetails, cartItems }) => {
  const { t, lang } = useTranslation('checkout');

  const [cartData, , removeCartData] = usePersistedCartData();
  const [isLoading, setIsLoading] = useState(false);

  const isArabic = lang === LANGUAGE_AR;
  const updateModal = useUpdateModal();
  const removeCartItems = useRemoveCartItems();
  const { cartId, isCartAuthorized } = cartData || {};
  const updateCartValues = useUpdateCartValues({ cartId, isCartAuthorized });

  return {
    removeItemsOutOfSync: async () => {
      setIsLoading(true);
      const newCartDetails = await mutateCartDetails();
      const itemsOutOfSync = newCartDetails?.cartItems?.filter(item => item.posSynced === false);
      const itemsId = itemsOutOfSync?.map(items => items.id);
      const itemsNames = itemsOutOfSync
        ?.map(items => `\n - ${isArabic ? items.menuItem?.titleAr : items.menuItem?.titleEn}`)
        .join('');

      updateModal({
        isOpen: true,
        showCloseIcon: false,
        title: t('errors:checkout.PosOutOfSync.title'),
        description: t('errors:checkout.PosOutOfSync.description', { items: itemsNames }),
        confirmButtonText: t('errors:checkout.PosOutOfSync.confirm'),
        onConfirm: async () => {
          updateModal({ isOpen: false });
          if (itemsOutOfSync?.length === cartItems?.length) removeCartData();
          else {
            const data = await removeCartItems({ cartId: cartData?.cartId, cartItemIds: itemsId });
            updateCartValues(data);
          }
          setIsLoading(false);
        },
      });
    },
    isLoading,
  };
};
